import React from "react";
import { Badge } from "reactstrap";
import { Icon } from "components/Structure/IconComponent";
import { useSkin } from "@hooks/useSkin";

import { StyledAvatar } from "../wrapperArquivaMix.styles";
import { ContentList, CheckIcon } from "../OportunidadeNegociacao/list.styles";

export const RiscoAssumidoContent = () => {
  const { skin } = useSkin();

  return (
    <>
      <div className="d-flex align-items-center gap-1">
        <StyledAvatar skin={skin}>
          <Icon name="cadeado" color="#fff" size={48} />
        </StyledAvatar>
        <div>
          <h1 className="text-dark text-left fs-3 fw-bolder">
            Contéudo Exclusivo
          </h1>
          <Badge color="light-primary" pill>
            Apenas para assinantes premium
          </Badge>
        </div>
      </div>

      <div className="mt-1">
        <div className="mb-2">
          <p className="text-dark fw-bolder">
            Seu lucro pode estar em risco — e você ainda não viu.
          </p>
        </div>
        <div>
          <span className="text-dark m-0">
            Quando <b>NCM, CEST, CST</b> ou <b>alíquotas</b> estão incorretos,
            cada venda cria um risco fiscal silencioso.
          </span>
          <p className="text-dark">
            Se houver autuação, você paga imposto, multa e juros — e sua margem
            diminui imediatamente.
          </p>
        </div>

        <div className="">
          <p className="text-dark m-0">
            A <b>nota com informações da Mix Fiscal</b> mostra{" "}
            <b>item a item:</b>
          </p>
          <ContentList className="list-unstyled">
            <li className="text-dark">
              <CheckIcon>✔</CheckIcon> NCM aplicado
            </li>
            <li className="text-dark">
              <CheckIcon>✔</CheckIcon> CEST utilizado
            </li>
            <li className="text-dark">
              <CheckIcon>✔</CheckIcon> CST configurado
            </li>
            <li className="text-dark">
              <CheckIcon>✔</CheckIcon> Alíquotas usadas
            </li>
            <li className="text-dark">
              <CheckIcon>✔</CheckIcon> Diferenças que geram risco
            </li>
            <li className="text-dark">
              <CheckIcon>✔</CheckIcon> Multas e valores estimados por produto
            </li>
          </ContentList>
        </div>
      </div>
    </>
  );
};
